'use strict';

var homeapp = angular.module("homeapp", []);

(function () {
    'use strict';   

    homeapp.service("dataService", dataService);
    dataService.$inject = ['$http', '$q'];

    homeapp.directive("typeaheadhome", typeaheadhome);
    typeaheadhome.$inject = ['dataService', '$location', '$timeout'];

    function typeaheadhome(dataService, $location, $timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, elm, attrs) {

            $(elm).typeahead({
                minLength: 3,
                highlight: true
            },
            {
                displayKey: 'Name',
                limit: 50,
                source: function (query, syncResults, asyncResults) {
                    var req = dataService.suggest(query);
                    $scope.vm.handlePendingRequests("suggest", req);

                    req.promise.then(function (res) {
                        asyncResults(res.data.Data);
                    });
                },
                templates: {
                    suggestion: function (data) {
                        return '<p>' + data.Name + '</p>';
                    }
                }
            });
            $(elm).bind('typeahead:select', function (ev, item) {
                $scope.vm.searchSelectedItem = item;
                $scope.vm.filter.suburb = null;
                $scope.vm.filter.categories = null;
                $scope.vm.filter.cuisineID = null;
                $scope.vm.filter.merchantID = null;

                if (item.Type === "Merchant") {
                    $scope.vm.filter.merchantID = item.ID;                    
                }
                if (item.Type === "Suburb") {
                    $scope.vm.filter.suburb = item.ID;                    
                }
                if (item.Type === "Category") {
                    $scope.vm.filter.categories = item.ID;                    
                }
                if (item.Type === "Cuisine") {                    
                    $scope.vm.filter.cuisineID = item.ID;                    
                }
                $scope.vm.search();
            });
            $(elm).bind('typeahead:change', function (ev, item) {
                if ($scope.vm.searchSelectedItem == null || $scope.vm.searchSelectedItem.Name !== item) {
                    $scope.vm.filter.merchantID = null;
                    $scope.vm.filter.suburb = null;
                    $scope.vm.filter.categories = null;
                    $scope.vm.filter.cuisineID = null;
                    $(elm).typeahead('val', "");
                    $scope.vm.filter.searchTerm = "";
                    $scope.vm.searchSelectedItem = null;                    
                }
            });
        }
    }




    homeapp.controller("homeCtrl", homeCtrl);
    homeCtrl.$inject = ['dataService', '$httpParamSerializer'];

    function homeCtrl(dataService, $httpParamSerializer) {
        var vm = this;
        vm.handlePendingRequests = handlePendingRequests;
        vm.search = search;
        vm.filterBySuggestion = filterBySuggestion;
        
        init();

        function filterBySuggestion(e) {
            if (e.keyCode === 13) {
                search();
            }
        }

        function search() {
            var url = "/search?" + $httpParamSerializer(vm.filter);
            window.location = url;
        }

        function handlePendingRequests(callStore, req) {
            vm[callStore] = vm[callStore] || [];
            vm[callStore].forEach(function (r) {
                r.cancel("new request");
                vm[callStore].splice(vm[callStore].indexOf(r), 1);
            });
            vm[callStore].push(req);
        }

        function init() {
            if (navigator.geolocation && window.location.protocol === "https:") {
                navigator.geolocation.getCurrentPosition(function (position) {

                        var links = $("a[href^='/Search']");
                        links.each(function () {
                            var href = $(this).attr("href");
                            href += href.indexOf("?") >= 0 ? "&" : "?";
                            href += "centerLat=" + position.coords.latitude + "&centerLng=" + position.coords.longitude + "&zoom=12";
                            $(this).attr("href", href);
                        });

                    },
                    function (err) { },
                    { maximumAge: 60000, timeout: 5000, enableHighAccuracy: true });
            }
        }
    };
})();

$(window).load(function() {
    $('.royalSlider').each(function(){ 
        if ($(this).find('.item').length){
            $(".slider-loading").fadeOut("slow");
            $(".template-homepage .royalSlider").css('display', 'block').royalSlider({
                            // options go here
                            // as an example, enable keyboard arrows nav
                            
                            transitionType: 'fade',
                            keyboardNavEnabled: true,
                            controlNavigation: "none",
                            autoHeight: true,
                            loop: true,
                            loopRewind: true,
                            navigateByClick: false,
                            autoPlay: {
                                enabled: true,
                                pauseOnHover: true,
                                delay: 5000
                            }
            });
        }else{
            $('.slider-section').hide();
        }
    })
});